<div class="content grid-1-auto md3-surface">
  <div class="content">
    <div class="app-layout-message">
      <div class="grid-1-auto md3-card-on-surface solid-d-100">
        <h5 class="app-space-left_1">
          {{Message.msgBetreff}}
        </h5>
        <div class="spawn-reverse">
          <ng-container>
            <exg-checkbox *ngIf="excSecurity.isFeatured('MSGDONE')" class="md-check-reverse typo-small" [ngModel]="Message.msgFIN" (ngModelChange)="setDone($event)"
                          [caption]="getResource('FinishCaption')"
                          type="switch">
            </exg-checkbox>
            <app-exg-dropdown *ngIf="excSecurity.isFeatured('MSGCATEGORY')"
                              [list]="enumSvc.getEnumerationList('NachrichtKategorie')"
                              listdisplay="enmText"
                              position="abovecenter" class="typo-small"
                              [label]="getResource('Category') + ': ' + enumSvc.getEnumerationText('NachrichtKategorie',Message.msgNachrichtKategorie_enmIdent)"
                              (change)="changeMessageCategory($event)">
            </app-exg-dropdown>
          </ng-container>

	        <app-exg-dropdown>
		        <ng-template #hostTemplate>
			        <i class="search-filter-action fal fa-link app-space_075"
                 *ngIf="Message.msg_enmIdent_NachrichtTyp === 2"></i>
		        </ng-template>
		        <ng-template #contentTemplate let-popup>
              <div class="md-menu-item" (click)="openLinkCase();popup.close();">{{getResource("ActionMenu.LinkCase")}}</div>
              <div class="md-menu-item" (click)="openLinkTask();popup.close();">{{getResource("ActionMenu.LinkTask")}}</div>
		        </ng-template>
	        </app-exg-dropdown>

	        <app-exg-dropdown>
		        <ng-template #hostTemplate>
			        <i class="search-filter-action fal fa-unlink app-space_075"
                 [class.disabled]="LinkedTasks.data.length + LinkedCases.data.length === 0"
                 *ngIf="Message.msg_enmIdent_NachrichtTyp === 2"></i>
		        </ng-template>
		        <ng-template #contentTemplate let-popup>
              <div class="md-menu-item"
                   *ngFor="let linkedCase of LinkedCases.data"
                   (click)="unLink(linkedCase, 0);popup.close();">
                {{linkedCase.auNr}}
              </div>
              <div class="md-menu-item"
                   *ngFor="let linkedTask of LinkedTasks.data"
                   (click)="unLink(linkedTask, 1);popup.close();">
                {{linkedTask.vorgNr}}
              </div>
		        </ng-template>
	        </app-exg-dropdown>

          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-filter-action fal fa-ellipsis-v app-space_075"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <div class="md-menu-item"
                   (click)="openReply();popup.close();">{{getResource("ActionMenu.Reply")}}
              </div>
              <div class="md-menu-item"
                   (click)="openForward();popup.close();">{{getResource("ActionMenu.Forward")}}
              </div>
              <div class="md-menu-item"
                   *ngIf="Message.msg_enmIdent_NachrichtTyp === 2"
                   (click)="createNewCase();popup.close();">{{getResource("ActionMenu.Case")}}
              </div>
              <div class="md-menu-item"
                   *ngIf="LinkedCases.data.length === 1 && Message.msg_enmIdent_NachrichtTyp === 2"
                   (click)="createNewTask();popup.close();">{{getResource("ActionMenu.Task")}}
              </div>
            </ng-template>
          </app-exg-dropdown>
        </div>
        <div>
          <div class="typo-container-s-s-q app-space-left_1" style="padding: 0">
            <span class="typo-small">{{getResource("From")}}:</span>
            <span class="typo-small">{{Message.msgAbsender}}</span>
            <q></q>
            <ng-container *ngIf="MessageReceipients.msgEmpfaengerTo.length > 0">
              <span class="typo-small">{{getResource("To")}}:</span>
              <span class="typo-small">
                <ng-container *ngFor="let rec of MessageReceipients.msgEmpfaengerTo; let first = first;">
                <ng-container *ngIf="!first">; </ng-container>
                  {{rec.empf_KontVal}}
                </ng-container>
              </span>
              <q></q>
            </ng-container>
            <ng-container *ngIf="MessageReceipients.msgEmpfaengerCc.length > 0">
              <span class="typo-small">{{getResource("Cc")}}:</span>
              <span class="typo-small">
                <ng-container *ngFor="let rec of MessageReceipients.msgEmpfaengerCc; let first = first;">
                  <ng-container *ngIf="!first">; </ng-container>{{rec.empf_KontVal}}
                </ng-container>
              </span>
              <q></q>
            </ng-container>
          </div>
        </div>
        <div class="list-metadata"
             style="padding-right: 0.75rem">
          <em class="typo-right typo-small">
            {{getResource("Type")}}: {{enumSvc.getEnumerationText("NachrichtTyp",
            Message.msg_enmIdent_NachrichtTyp)}}
          </em>
          <em class="typo-right typo-small">
            {{getResource("Priority")}}: {{enumSvc.getEnumerationText("NachrichtPrio",
            Message.msg_enmIdent_NachrichtPrio)}}
          </em>
          <em class="typo-right typo-small">
            {{Message.msgCRD | excDate:'Globals.DateTimeFormatShort'}}
          </em>
        </div>
      </div>
      <div class="flex-container">
        <div class="flex-row">
          <div class="md3-card-on-surface width-300"
               *ngFor="let attachment of MessageAttachments.data; index as selectedIndex;"
               (click)="MessageAttachments.RowDblClick(selectedIndex)"
               [class.app-space-top]="MessageAttachments.data.length > 0">
            <div class="grid-auto-1 app-cursor-pointer">
              <div class="">
                <span style="font-size: medium"
                      [tooltip]="getRessource('tooltip.open')" flow="right">
                  <img src="{{excRestService.computeUrl('ImageThumbnail120',{dokID: attachment.dokID})}}"
                       alt="attachmentThumb"
                       class="app-thumb"/>
                </span>
              </div>
              <div class="layout-auto-1-auto">
                <div class="typo-small">
                  {{enumSvc.getEnumerationText('DokTyp', attachment.dok_enmIdent_DokTyp)}}
                </div>
                <div>
                  <strong>{{attachment.dokName}}{{attachment.dokErw}}</strong>
                </div>
                <div class="list-metadata typo-small typo-left">
                  {{appSvc.file.calcFileSize(attachment.dokGroesse)}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md3-card-on-surface app-space-top app-border-none">
        <editor [(ngModel)]="Message.msgText"
                class="content app-editor"
                [init]="MCEinitDisabled" [disabled]="true">
        </editor>
      </div>
    </div>
    <div class="drawer-container right app-table-drawer">
      <div [ngClass]="{'visible': rightDrawerVisible }"
           class="drawer-content md3-card-on-surface app-space-right_0">
        <div class="content width-500 ">
          <app-exg-tab-v2 #VCrightTabControl [header]="rightTabs">
            <ng-template #pages>
              <div class="content app-space-left"
                   *ngIf="LinkedTasks.data.length > 0">
	              <!--Vorgang-->
	              <div class="app-space-right">
		              <app-drawer-task-details [data]="TaskSummary.taskDetails.data"
		                                       [oeList]="TaskSummary.oeList.data"
		                                       [Schadenort]="TaskSummary.Schadenort.data">
		              </app-drawer-task-details>
	              </div>
	              <!--Vorgang-->
	              <!-- Auftrag-->
	              <div class="app-space-right search-filter-seperator">
		              <app-drawer-case-details
			              [data]="TaskSummary.caseDetails.data"
			              [oeList]="TaskSummary.oeList.data"
			              [Schadenort]="TaskSummary.Schadenort.data">
		              </app-drawer-case-details>
	              </div>
	              <!--Auftrag-->
              </div>
              <div class="content app-space-left"
                   *ngIf="LinkedCases.data.length > 0">
	              <!-- Auftrag-->
	              <div class="app-space-right">
                  <app-drawer-case-details
                    [data]="CaseSummary?.caseDetails?.data"
                    [oeList]="CaseSummary?.oeList?.data"
                    [Schadenort]="CaseSummary?.Schadenort?.data">
                  </app-drawer-case-details>
	              </div>
	              <!--Auftrag-->
              </div>
            </ng-template>
          </app-exg-tab-v2>
        </div>
      </div>
    </div>
  </div>
  <div class="app-drawer md3-card-on-surface">
    <i (click)="rightDrawerVisible = LinkedCases.data.length === 0 && LinkedTasks.data.length === 0 ? false : !rightDrawerVisible"
       [class.disabled]="LinkedCases.data.length === 0 && LinkedTasks.data.length === 0"
       class="search-filter-action fal fa-info">
    </i>
    <i class="search-filter-seperator"></i>
	  <i *ngIf="LinkedCases.data && LinkedCases.data.length > 0 && excSecurity.isFeatured('CASEREAD')"
	     (click)="appSvc.Case.Workspace.OpenTabV2(LinkedCases.data[0].auID)"
	     class="search-filter-action fal fa-folder">
	  </i>
    <i *ngIf="LinkedTasks.data && LinkedTasks.data.length > 0 && excSecurity.isFeatured('TASKREAD')"
       (click)="appSvc.Task.Workspace.OpenTabV2(LinkedTasks.data[0].vorgID)"
       class="search-filter-action fal fa-clipboard-list">
    </i>
  </div>
<!--   <div class="content" *ngIf="MessageAttachments.data.length > 0 || LinkedCases.data.length > 0 || LinkedTasks.data.length > 0"> -->
<!--     <ng-container *ngIf="LinkedCases.data.length > 0"> -->
<!--       <div class="md3-card-on-surface app-space-top"> -->
<!--         <div class="grid-1-auto md3-masonary-card__title&#45;&#45;wrapper app-space_none"> -->
<!--           <h2>{{getGlobal('Cases')}}</h2> -->
<!--         </div> -->
<!--         <exg-data-list [rowSource]="LinkedCases.data" -->
<!--                        [allowMultiSelection]="false" -->
<!--                        (RowDblClick)="openCase($event)"> -->
<!--           <ng-template #rowTemplate let-row> -->
<!--             <div class="app-list list-row list-single-line-auto-1" style="padding:0.5rem"> -->
<!--               <div></div> -->
<!--               <div class="grid cols-2"> -->
<!--                 <div><i class="fal fa-eye" (click)="openCase(row.auID)"></i></div> -->
<!--                 <div> -->
<!--                   <div class="typo-small">{{getGlobal("Case")}}</div> -->
<!--                   <div><strong>{{row.auNr}}</strong></div> -->
<!--                 </div> -->
<!--               </div> -->
<!--             </div> -->
<!--           </ng-template> -->
<!--         </exg-data-list> -->
<!--       </div> -->
<!--     </ng-container> -->
<!--     <ng-container *ngIf="LinkedTasks.data.length > 0"> -->
<!--       <div class="md3-card-on-surface app-space-top"> -->
<!--         <div class="grid-1-auto md3-masonary-card__title&#45;&#45;wrapper app-space_none"> -->
<!--           <h2>{{getGlobal('Tasks')}}</h2> -->
<!--         </div> -->
<!--         <exg-data-list [rowSource]="LinkedTasks.data" -->
<!--                        [allowMultiSelection]="false" -->
<!--                        (RowDblClick)="openTask($event)"> -->
<!--           <ng-template #rowTemplate let-row> -->
<!--             <div class="app-list list-row list-single-line-auto-1" style="padding:0.5rem"> -->
<!--               <div></div> -->
<!--               <div class="grid cols-2"> -->
<!--                 <div><i class="fal fa-eye" (click)="openTask(row.vorgID)"></i></div> -->
<!--                 <div> -->
<!--                   <div class="typo-small">{{getGlobal("Task")}}</div> -->
<!--                   <div><strong>{{row.vorgNr}}</strong></div> -->
<!--                 </div> -->
<!--               </div> -->
<!--             </div> -->
<!--           </ng-template> -->
<!--         </exg-data-list> -->
<!--       </div> -->
<!--     </ng-container> -->
<!--   </div> -->
</div>

